var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgImageIcon = function SvgImageIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M5.86011 3.46172C6.38571 1.92276 8.04546 1.06818 9.60284 1.53466L21.4231 5.07515C23.0403 5.55953 23.9242 7.27766 23.3785 8.87568L19.6486 19.7969C19.123 21.3359 17.4633 22.1905 15.9059 21.724L4.08559 18.1835C2.46844 17.6991 1.58447 15.981 2.13024 14.383L5.86011 3.46172Z",
    fill: "#DEE2E6"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M3.14417 8C3.14417 6.34315 4.48731 5 6.14417 5H18.517C20.1738 5 21.517 6.34315 21.517 8V17C21.517 18.6569 20.1738 20 18.517 20H6.14417C4.48731 20 3.14417 18.6569 3.14417 17V8ZM5.18559 17L9.7788 11L14.372 17H5.18559ZM16.4134 14C18.1046 14 19.4756 12.6569 19.4756 11C19.4756 9.34315 18.1046 8 16.4134 8C14.7223 8 13.3513 9.34315 13.3513 11C13.3513 12.6569 14.7223 14 16.4134 14Z",
    fill: "#212529"
  })));
};
export default SvgImageIcon;